import { MoreOutlined } from "@ant-design/icons";
import { Divider, Dropdown, Flex, FormListFieldData } from "antd";
import { FC } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

import { StyledMenuButton } from "./Styled";

interface ContractProductRowProps {
    productName: string;
    field: FormListFieldData;
    barcode: string;
    menuItems: {
        key: string;
        label: JSX.Element;
    }[];
    remove: (index: number) => void;
}

export const ContractProductRow: FC<ContractProductRowProps> = ({
    field,
    menuItems,
    productName,
    barcode,
    remove,
}) => {
    return (
        <Flex key={field.key} vertical gap={12}>
            <Flex justify="space-between" align="flex-start" gap={4}>
                <Flex flex={1} vertical gap={4}>
                    <PrimaryText>
                        {productName}, {barcode}
                    </PrimaryText>
                </Flex>

                <Dropdown
                    menu={{
                        items: menuItems,
                        onClick: () => remove(field.name),
                    }}
                >
                    <StyledMenuButton type="text" icon={<MoreOutlined />} />
                </Dropdown>
            </Flex>

            <Divider style={{ margin: 0 }} />
        </Flex>
    );
};
